import { useState, useEffect, useMemo } from 'react';

const useCustomUI = (variables, customizeStructure) => {
	const [customUI, setCustomUI] = useState({});

	const StyleDeclarations = useMemo(() => window.getComputedStyle(document.documentElement), []);

	useEffect(() => {
		const getStyleProperty = variableName => StyleDeclarations.getPropertyValue(variableName) ?? '';

		const newCustomUI = Object.fromEntries(
			Object.entries(variables).map(([key, value]) => [key, getStyleProperty(value)])
		);

		setCustomUI(newCustomUI);
	}, [StyleDeclarations, variables]);

	return customizeStructure(customUI);
};

export default useCustomUI;
